import { OrderConfig } from "@kanpla/types";

export const calculateConfigTotal = (config: OrderConfig) =>
  Object.values(config?.options || {}).reduce(
    (acc, option) => acc + (option.amount || 0) * (option.extraPrice || 0),
    0
  );
